<template>
  <v-sheet class="pa-4 primary lighten-2">
    <v-text-field
      v-model="search"
      label="Wyszukaj użytkownika"
      dark
      flat
      solo-inverted
      hide-details
      clearable
      clear-icon="mdi-close-circle-outline"
      @input="$emit('searchChange', search)"
    ></v-text-field>
    <v-row v-if="innerRoles" class="px-2">
      <v-checkbox
        v-for="role in innerRoles"
        :key="role.id"
        v-model="checkedRoles"
        :value="role.id"
        class="mr-2"
        dark
        hide-details
        :label="role.display"
        @change="filterChanged"
      />
    </v-row>
  </v-sheet>
</template>

<script>
import RolesServiceApi from '@/api/rolesServiceApi';

export default {
  props: {
    roles: {
      type: Array,
      default: null
    }
  },
  data: function() {
    return {
      search: '',
      innerRoles: null,
      checkedRoles: []
    };
  },
  async mounted() {
    try {
      const { data } = await new RolesServiceApi().getRoles();
      this.innerRoles = data.result.items.map(role => {
        return {
          ...role,
          name: role.name.toUpperCase(),
          display:
            role.displayName === 'Admin'
              ? 'Administrator'
              : role.displayName === 'CourseAdmin'
              ? 'Administrator szkoleń'
              : role.displayName === 'Teacher'
              ? 'Nauczyciel'
              : role.displayName
        };
      });
    } catch (e) {
      console.error(e);
      // TODO: handle
    }
  },
  methods: {
    filterChanged() {
      this.$emit('update:roles', this.checkedRoles);
    }
  }
};
</script>
